import logo from '../../assets/logo-full.png';

interface HeaderProps {
  isScrolled: boolean;
  scrollToSection: (sectionId: string, text?: string) => void;
}

interface NavItem {
  id: string;
  label: string;
}

const navigationItems: NavItem[] = [
  { id: 'inicio', label: 'Início' },
  { id: 'recursos', label: 'Recursos' },
  { id: 'capturas', label: 'Sistema' },
  { id: 'precos', label: 'Preços' },
  // { id: 'depoimentos', label: 'Clientes' },
  { id: 'contato', label: 'Contato' }
];


function Header({ isScrolled, scrollToSection }: HeaderProps) {
  const requestDemo = () => {
    const message = 'Olá, tenho interesse em solicitar uma demonstração.';
    scrollToSection('contato', message)
  }
  const logoStyle = {
    height: '4rem'
  }
  return (
    <header className={`fixed w-full top-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white/95 backdrop-blur-lg shadow-lg' : 'bg-white/95 backdrop-blur-lg'
      }`}>
      <nav className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex justify-between items-center">
          <div className="flex items-center">
            <img src={logo} alt="Menu Master" className="w-auto" style={logoStyle} />
          </div>

          <div className="hidden md:flex space-x-8">
            {navigationItems.map((item) => (
              <button
                key={item.id}
                onClick={() => scrollToSection(item.id)}
                className="text-gray-700 hover:text-indigo-600 font-medium transition-colors duration-200"
              >
                {item.label}
              </button>
            ))}
          </div>

          {/* <button
            onClick={() => scrollToSection('contato')}
            className="bg-gradient-to-r from-indigo-600 to-purple-600 text-white px-6 py-3 rounded-full font-semibold hover:transform hover:-translate-y-1 hover:shadow-xl transition-all duration-300"
          >
            Solicitar Demo
          </button> */}

          <button
            onClick={requestDemo}
            className="bg-orange-500 text-white px-6 py-2 rounded-lg hover:bg-orange-600 transition font-medium"
          >
            Solicitar Demo
            {/* Começar Agora */}
          </button>
        </div>
      </nav>
    </header>
  );
}

export default Header;